import { Bold, Highlighter, Italic, Underline, Waves } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { Editor } from '@tiptap/react'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

export interface TextFormatButton {
  icon: LucideIcon
  label: string
  run: () => void
  active: boolean
}

/**
 * Кнопки форматирования текста составного блока — общие для панели справа
 * (`TextFormatToolbar`) и быстрой панели над элементом (`QuickTextFormat`).
 * Выделения (маркер / подчёркивание / волна) взаимоисключающие: включая одно,
 * снимаем два других.
 */
export const textFormatButtons = (activeEditor: Editor): TextFormatButton[] => {
  const m = messagesNow(messages)
  return [
    {
      icon: Bold,
      label: m.bold,
      run: () => activeEditor.chain().focus().toggleBold().run(),
      active: activeEditor.isActive('bold'),
    },
    {
      icon: Italic,
      label: m.italic,
      run: () => activeEditor.chain().focus().toggleItalic().run(),
      active: activeEditor.isActive('italic'),
    },
    {
      icon: Highlighter,
      label: m.highlight,
      run: () =>
        activeEditor
          .chain()
          .focus()
          .unsetMark('underline')
          .unsetMark('wavyUnderline')
          .toggleHighlight()
          .run(),
      active: activeEditor.isActive('highlight'),
    },
    {
      icon: Underline,
      label: m.underline,
      run: () =>
        activeEditor
          .chain()
          .focus()
          .unsetMark('highlight')
          .unsetMark('wavyUnderline')
          .toggleUnderline()
          .run(),
      active: activeEditor.isActive('underline'),
    },
    {
      icon: Waves,
      label: m.wavy,
      run: () =>
        activeEditor
          .chain()
          .focus()
          .unsetMark('highlight')
          .unsetMark('underline')
          .toggleWavyUnderline()
          .run(),
      active: activeEditor.isActive('wavyUnderline'),
    },
  ]
}
